export const firebaseConfig = {
  apiKey: "AIzaSyAwbm1IDS9mvdR6dvr9G_Bq8AT_KllmnvY",
  authDomain: "ninosquedibujan-campus.firebaseapp.com",
  databaseURL: "https://ninosquedibujan-campus.firebaseio.com",
  projectId: "ninosquedibujan-campus",
  storageBucket: "ninosquedibujan-campus.appspot.com",
  messagingSenderId: "1081497198087",
  appId: "1:1081497198087:web:6007dfa1e5c79e312994a2"
}
